const DEFAULT_STUN_SERVER_URLS = [
  'stun:stun.l.google.com:19302',
  'stun:stun1.l.google.com:19302',
  'stun:stun2.l.google.com:19302',
];

interface TrainingForkerSipConfig {
  stunServer?: string;
  stunServerAlt?: string;
  iceServerUsername?: string;
  iceServerCredential?: string;
}

function normalizeStunUrl(url: string): string {
  return /^stun:/i.test(url) ? url : `stun:${url}`;
}

export function buildTrainingIceServers(
  sipConfig?: TrainingForkerSipConfig
): RTCIceServer[] {
  const configuredStunUrls = [
    sipConfig?.stunServer?.trim(),
    sipConfig?.stunServerAlt?.trim(),
  ].filter((url): url is string => Boolean(url));

  const trainingIceServers: RTCIceServer[] = [];
  const uniqueStunUrls = new Set(
    (configuredStunUrls.length > 0
      ? configuredStunUrls
      : DEFAULT_STUN_SERVER_URLS
    ).map(normalizeStunUrl)
  );

  for (const stunUrl of uniqueStunUrls) {
    trainingIceServers.push({ urls: stunUrl });
  }

  // Intentionally do not include TURN servers for training; only STUN is required.

  return trainingIceServers;
}
